import { createContext, useContext } from 'react';

export const WizardContext = createContext({});

// eslint-disable-next-line react-refresh/only-export-components
export const useWizard = () => useContext(WizardContext);

// eslint-disable-next-line react/display-name, react-refresh/only-export-components
export const withWizard = Component => props =>
  (
    <WizardContext.Consumer>
      {context => <Component {...props} wizard={context} />}
    </WizardContext.Consumer>
  );
